import React, {Component} from 'react';
import {connect} from 'react-redux'

import {locale} from '../locale/AppLocale'
import Loader from "../Components/Loader";
import {Field, reduxForm, change as changeForm, formValueSelector, getFormValues} from 'redux-form'
import ProductInput from '../Components/ProductInput'
import * as sellActions from '../actions/sellActions'
import ImageGallery from 'react-image-gallery';
import "react-image-gallery/styles/css/image-gallery.css";
import { Tooltip as ReactTooltip } from 'react-tooltip'
import * as authActions from '../actions/authActions'


import {push as routerPush} from 'react-router-redux'
import {Link} from 'react-router-dom'
import ShooqModal from '../Components/ShooqModal';
import PiecesModal from '../Components/PiecesModal';
import Config from '../Helpers/Config';
import axios from 'axios';

import {NotificationManager} from '../Helpers/NotificationManager';;

const selector = formValueSelector('sellForm');

import {validateSeller} from '../Helpers/ValidateProduct'
import {FixFormValues} from "../Helpers/FixFormValues";
import {GetEntityAttribute} from "../Helpers/Entity";


axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded';
axios.defaults.headers['X-Requested-With'] = 'XMLHttpRequest';
axios.defaults.withCredentials = true;
axios.defaults.crossDomain = true;

const checkBoxInput = ({input, id, type}) => {
    return (
        <input
            {...input}
            id={id}
            type={type}/>
    );
};

const inputMessage = ({meta}) => {
    return (
        <div className={` input-c  ` + (meta.error ? 'has-error ' : '')}>
            {meta.touched
            && ((meta.error &&
            <div className="has-error"><span className="help-block is-error">{meta.error}</span></div> )
            || (meta.warning && <span>{meta.warning}</span>))}
        </div>
    )
}

class Sell extends Component {

    constructor(props) {
        super(props);
        this.state = {
            openModal: false,
            requiresPiecesUpdate: false
        };
        this.onSubmit = this.onSubmit.bind(this);
        this.showModal = this.showModal.bind(this);
        this.closeModal = this.closeModal.bind(this);
        this.updateAddress = this.updateAddress.bind(this);
        this.onSubmitPieces = this.onSubmitPieces.bind(this);
        this.onRefusePieces = this.onRefusePieces.bind(this);
        this.hasSelfShipping = this.hasSelfShipping.bind(this);
        this.canShippingToRegion = this.canShippingToRegion.bind(this);
        this.getSelectedAddress = this.getSelectedAddress.bind(this);
    }

    componentDidMount() {
        this.props.fetchProductInfo(this.props.auth.business.id, this.props.match.params.productId);
    }

    onSubmit(values) {
        if (values.price < 100) {
            this.setState({
                requiresPiecesUpdate: true
            })
        } else {
            this.props.toggleFormActionStatus(true);
            this.sendCreateRequest(values);
        }
    }

    onSubmitPieces(price) {
        let values = this.props.selectorAll();
        values.pieces = price[0].pieces;
        values.price = price[0].price;
        this.props.toggleFormActionStatus(true);
        this.sendCreateRequest(values);
    }


    onRefusePieces() {
        let values = this.props.selectorAll();
        this.props.toggleFormActionStatus(true);
        this.sendCreateRequest(values);
    }

    sendCreateRequest(values) {


        axios.post(Config.api() + 'product/sell/' + this.props.match.params.productId, FixFormValues({
            title_ar: values.title_ar,
            price: values.price,
            old_price: values.old_price,
            quantity: values.quantity,
            sku: values.sku,
            notes: values.notes,
            handling_time: values.handling_time,
            pcondition: values.pcondition,
            shipping_delivery_option: values.shipping_delivery_option,
            free_shipping: values.free_shipping ? 1 : 0,
            free_shipping_jerusalem: values.free_shipping_jerusalem ? 1 : 0,
            free_shipping_48: values.free_shipping_48 ? 1 : 0,
            free_shipping_gaza: values.free_shipping_gaza ? 1 : 0,
            shipping_by_seller: values.shipping_by_seller ? 1 : 0,
            product_id: this.props.match.params.productId,
            business_id: this.props.auth.business.id,
            pickup_from: values.pickup_from,
            pieces: values.pieces ? values.pieces : 1
        }), {
            withCredentials: Config.withCredentials()
        }).then((response) => {
            if (response.data.status === true) {
                NotificationManager.success(locale.get('sell_product_added_successfully'), values.title_ar);
                this.props.navigateTo(`/${this.props.match.params.businessSlug}/manage`);
            } else {
                NotificationManager.error(locale.get('an_error_occurred_while_submitting_form'));
            }
            this.props.toggleFormActionStatus(false);
        }).catch((error) => {
            if (error.response.status === 401) {
                this.props.requiresReLogin();
            } else {
                NotificationManager.error(locale.get('an_error_occurred_while_submitting_form'));
            }
            this.props.toggleFormActionStatus(false);
        });
    }

    getProductImages() {
        let images = [];
        this.props.sell.images.forEach((img, index) => {
            images.push({original: img.full, thumbnail: img.thumb});
        });
        return images;
    }

    showModal() {
        this.setState({openModal: true});
    }

    closeModal(...proxy) {
        this.setState({openModal: false});
    }

    renderModalContent() {
        let product = this.props.sell;
        return (
            <div>

                <div className="product-details">
                    {
                        product.images.length > 0 ? (
                            <div className="product-details--gallery">
                                <ImageGallery
                                    thumbnailPosition={'bottom'}
                                    items={this.getProductImages()}
                                    slideInterval={2000}
                                    showPlayButton={false}
                                />
                            </div>
                        ) : ('')
                    }
                    <div
                        className={`product-details--attributes ` + (product.images.length === 0 ? ' no-gallery ' : '') }>

                        <ul className="product-details--props">
                            {product.attributes[0] && product.attributes[0].attributes.map((property, index) => {
                                if (index < 10) {
                                    return (
                                        <li key={index}>
                                            <span className="product-details--prop-name">{GetEntityAttribute(property,'title')}: </span>
                                            <span className="product-details--prop-value">{GetEntityAttribute(property,'value_text')}</span>
                                        </li>
                                    );
                                }
                                return '';
                            })}
                        </ul>
                    </div>
                </div>
                <div className="clearfix"></div>
                <div className="mt-30">
                    {product.attributes[0] && product.attributes.map((propertyGroup, index) => {
                        let className = 'table ';
                        if (index > 0) {
                            className += ' mt-30 ';
                        }

                        return (
                            propertyGroup.attributes && propertyGroup.attributes.length > 0 && <div key={index}>
                                <table className={className} width="100%">
                                    <thead>
                                    <tr>
                                        <td colSpan="2" className="table--head">{propertyGroup.name}</td>
                                    </tr>
                                    </thead>
                                    <tbody>
                                    {  propertyGroup.attributes.map((property, index) => {
                                        return (
                                            <tr key={index}>
                                                <th className="bg-white" width="50%">{GetEntityAttribute(property,'title')}</th>
                                                <td className="bg-white" width="50%">{GetEntityAttribute(property,'value_text')}</td>
                                            </tr>
                                        );
                                    })
                                    }
                                    </tbody>
                                </table>
                                <div className="clearfix"></div>
                            </div>
                        );
                    })
                    }

                </div>
                {
                    (product.description_ar && product.description_ar.length > 0) ? (
                        <div>
                            <table className='table mt-30' width="100%">
                                <thead>
                                <tr>
                                    <td className="table--head">{locale.get('product_details')}</td>
                                </tr>
                                </thead>
                                <tbody>
                                <tr>
                                    <td className="bg-white no-hover"
                                        dangerouslySetInnerHTML={this.createMarkup(product.description_ar)}/>
                                </tr>
                                </tbody>
                            </table>
                            <div className="clearfix"/>
                        </div>
                    ) : ('')
                }

            </div>
        );
    }

    createMarkup(string) {
        return {__html: string};
    }

    updateAddress(newAddress) {
        this.props.changeForm('pickup_from', newAddress.id);
    }

    getSelectedAddress() {
        const pickupFrom = parseInt(this.props.selector('pickup_from'), 10);
        const addresses = this.props.sell.seller.addresses;
        if (!pickupFrom || !addresses) {
            return false;
        }
        let index = addresses.findIndex((address) => {
            return address.id === pickupFrom;
        });
        if (!addresses[index]) {
            return false;
        }
        return addresses[index];
    }

    hasSelfShipping() {
        const selectedAddress = this.getSelectedAddress();
        if (!selectedAddress) {
            return false;
        }

        return selectedAddress.can_shipping_products || false;
    }

    canShippingToRegion(regionLocation) {
        const selectedAddress = this.getSelectedAddress();

        if (!selectedAddress || !selectedAddress['can_shipping_to_region']) {
            return false;
        }
        if (!selectedAddress['can_shipping_to_region'][regionLocation]) {
            return false;
        }
        return selectedAddress['can_shipping_to_region'][regionLocation];
    }

    render() {


        return (
            <Loader completed={this.props.sell.fetched}>
                {this.state.openModal ? (<ShooqModal showModal={this.state.openModal} onRequestClose={this.closeModal}
                                                      modalTitle={GetEntityAttribute(this.props.sell,'title')}
                                                      modalSubTitle={GetEntityAttribute(this.props.sell,'category_title')}>

                    {this.renderModalContent()}

                </ShooqModal>) : ('')}


                {
                    this.state.requiresPiecesUpdate &&
                    <PiecesModal
                        price={this.props.selector('price')}
                        onSubmit={this.onSubmitPieces}
                        onClose={() => this.setState({requiresPiecesUpdate: false})}
                        onRefuse={this.onRefusePieces}/>
                }


                <div className="panel-1">
                    <div className="panel-1--head bg-white">
                        {locale.get('sell_the_product')} <span>{GetEntityAttribute(this.props.sell,'title') || ''}</span>
                    </div>
                    <div className="panel-1--body is-full">
                        <div className="product-details clearfix">

                            {
                                this.props.sell.images.length > 0 ? (
                                    <div className="product-details--gallery">
                                        <ImageGallery
                                            thumbnailPosition={'bottom'}
                                            items={this.getProductImages()}
                                            slideInterval={2000}
                                            showPlayButton={false}
                                        />
                                    </div>
                                ) : ('')
                            }

                            <div
                                className={`product-details--attributes ` + (this.props.sell.images.length === 0 ? ' no-gallery ' : '') }>
                                <ul className="product-details--props">
                                    {this.props.sell.attributes[0] && this.props.sell.attributes[0].attributes.map((property, index) => {
                                        if (index < 10) {
                                            return (
                                                <li key={index}>
                                                    <span
                                                        className="product-details--prop-name">{GetEntityAttribute(property,'title')}: </span>
                                                    <span
                                                        className="product-details--prop-value">{GetEntityAttribute(property,'value_text')}</span>
                                                </li>
                                            );
                                        }
                                        return '';
                                    })}
                                    <li>
                                        <Link className="" to="#"
                                              onClick={ this.showModal }>{  locale.get('show_product_details') }</Link>
                                    </li>

                                </ul>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="panel-1">
                    <form className="form-horizontal" onSubmit={this.props.handleSubmit(this.onSubmit.bind(this)) }>
                        <div className="panel-1--body is-full">
                            <div className="inner-content-width">

                                <div className="tooltip-field" data-scroll-hide={true}
                                     data-event="click focusin focus" data-event-off="focusout" data-tip=''
                                     data-tooltip-id='tooltip_product_title_ar' data-iscapture="false" data-place="left"
                                     data-effect="solid" data-multiline="true">
                                    <Field
                                        type="text"
                                        name="title_ar"
                                        id="product_title_ar"
                                        component={ProductInput}
                                        className="form-control"
                                        label={locale.get('product_title_ar')}
                                        placeholder={locale.get('product_title_ar')}
                                        field={{}}/>
                                    <ReactTooltip
                                        id='tooltip_product_title_ar'>{locale.get('product_title_ar')}</ReactTooltip>
                                </div>


                                <div className="tooltip-field" data-scroll-hide={true}
                                     data-event="click focusin focus" data-event-off="focusout" data-tip=''
                                     data-tooltip-id='tooltip_quantity' data-iscapture="false" data-place="left"
                                     data-effect="solid" data-multiline="true">
                                    <Field
                                        type="text"
                                        name="quantity"
                                        id="quantity"
                                        component={ProductInput}
                                        className="form-control"
                                        label={locale.get('quantity')}
                                        placeholder={locale.get('quantity')}
                                        field={{}}/>
                                    <ReactTooltip
                                        id='tooltip_quantity'>{locale.get('sell_product_tooltip_quantity')}</ReactTooltip>
                                </div>

                                <div className="tooltip-field" data-tip='' data-scroll-hide={true}
                                     data-event="click focusin focus" data-event-off="focusout"
                                     data-tooltip-id='tooltip_price' data-iscapture="false" data-place="left"
                                     data-effect="solid" data-multiline="true">
                                    <Field
                                        type="text"
                                        name="price"
                                        id="price"
                                        component={ProductInput}
                                        className="form-control"
                                        label={locale.get('price')}
                                        placeholder={locale.get('price')}
                                        field={{}}/>
                                    <ReactTooltip
                                        id='tooltip_price'>{locale.get('sell_product_tooltip_price')}</ReactTooltip>
                                </div>
                                <div className="tooltip-field" data-tip='' data-scroll-hide={true}
                                     data-html="true"
                                     data-event="click focusin focus" data-event-off="focusout"
                                     data-tooltip-id='tooltip_old_price' data-iscapture="false" data-place="left"
                                     data-effect="solid" data-multiline="true">
                                    <Field
                                        type="text"
                                        name="old_price"
                                        id="old_price"
                                        component={ProductInput}
                                        className="form-control"
                                        label={locale.get('old_price')}
                                        placeholder={locale.get('old_price')}
                                        field={{}}/>
                                    <ReactTooltip
                                        id='tooltip_old_price'>{locale.get('sell_product_tooltip_old_price')}</ReactTooltip>
                                </div>

                                <div className="tooltip-field" data-tip='' data-scroll-hide={true}
                                     data-event="click focusin focus" data-event-off="focusout"
                                     data-tooltip-id='tooltip_sku' data-iscapture="false" data-place="left"
                                     data-effect="solid" data-multiline="true">
                                    <Field
                                        type="text"
                                        name="sku"
                                        id="sku"
                                        component={ProductInput}
                                        className="form-control"
                                        label={locale.get('sku')}
                                        placeholder={locale.get('sku')}
                                        field={{}}/>
                                    <ReactTooltip
                                        id='tooltip_sku'>{locale.get('sell_product_tooltip_sku')}</ReactTooltip>
                                </div>

                                <div className="tooltip-field"
                                     data-tip=''
                                     data-scroll-hide={true}
                                     data-tooltip-id='tooltip_notes'
                                     data-iscapture={false}
                                     data-place="left"
                                     data-html="true"
                                     data-effect="solid"
                                     data-multiline="true">
                                    <Field
                                        type="textarea"
                                        name="notes"
                                        id="notes"
                                        component={ProductInput}
                                        className="form-control"
                                        label={locale.get('seller_notes')}
                                        placeholder={locale.get('seller_notes')}
                                        field={{}}/>
                                    <ReactTooltip
                                        id='tooltip_notes'>{locale.get('sell_product_tooltip_notes')}</ReactTooltip>
                                </div>

                                <div className="tooltip-field" data-tip='' data-scroll-hide={true}
                                     data-event="click" data-event-off="focusout"
                                     data-tooltip-id='tooltip_handling_time' data-iscapture="true" data-place="left"
                                     data-effect="solid" data-multiline="true">
                                    <Field
                                        name="handling_time"
                                        id="handling_time"
                                        component={ProductInput}
                                        className="form-control"
                                        label={locale.get('handling_time')}
                                        placeholder={locale.get('handling_time')}
                                        field={{data_type: "dropdown", options: this.props.sell.handling_times}}/>
                                    <ReactTooltip
                                        id='tooltip_handling_time'>{locale.get('sell_product_tooltip_handling_time')}</ReactTooltip>
                                </div>
                                <div className="tooltip-field" data-tip='' data-scroll-hide={true}
                                     data-event="click" data-event-off="focusout"
                                     data-tooltip-id='tooltip_product_condition' data-iscapture="true" data-place="left"
                                     data-effect="solid" data-multiline="true">
                                    <Field
                                        name="pcondition"
                                        id="pcondition"
                                        component={ProductInput}
                                        className="form-control"
                                        ref="hand"
                                        label={locale.get('product_condition')}
                                        placeholder={locale.get('product_condition')}
                                        field={{data_type: "dropdown", options: this.props.sell.product_conditions}}/>

                                    <ReactTooltip
                                        id='tooltip_product_condition'>{locale.get('sell_product_product_condition')}</ReactTooltip>
                                </div>

                                <div className="addresses-list ">
                                    <div className="label">{locale.get('pickup_from')}</div>
                                    <div className="">
                                        {this.props.sell.seller.addresses.map((address, index) => {
                                            return (
                                                <div key={index}
                                                     onClick={() => {
                                                         this.updateAddress(address)
                                                     }}
                                                     className={ parseInt(this.props.selector('pickup_from'), 0) === parseInt(address.id, 0) ? `address--item is-active` : `address--item`}
                                                     htmlFor={`pickup_from-` + address.id}>
                                                    <label htmlFor={`pickup_from-` + address.id}>
                                                        <Field
                                                            type="radio"
                                                            name={`pickup_from`}
                                                            id={`pickup_from-` + address.id}
                                                            component={checkBoxInput}
                                                            className="form-control"
                                                            defaultChecked={true}
                                                            value={address.id.toString()}
                                                            field={{}}
                                                        />
                                                        <strong className="address--item--name">{address.name}</strong>
                                                        <div
                                                            className="address--item--address">{address.address_1}</div>
                                                        <div className="address--item--address">{address.address}</div>
                                                        <div className="address--item--phone">{address.phone}</div>
                                                    </label>
                                                </div>
                                            );
                                        })}
                                        <Field name={`pickup_from`} component={inputMessage}/>
                                    </div>
                                </div>


                                {
                                    this.hasSelfShipping() ? <div >
                                        <Field
                                            type="checkbox"
                                            name="shipping_by_seller"
                                            id="shipping_by_seller"
                                            data-tooltip-id="tooltip_shipping_by_seller"
                                            component={ProductInput}
                                            className="form-control"
                                            label={locale.get('shipper')}
                                            alt_label={locale.get('shipping_by_seller')}
                                            field={{}}/>
                                        <ReactTooltip
                                            id='tooltip_shipping_by_seller'>{locale.get('sell_product_tooltip_shipping_by_seller')}</ReactTooltip>
                                    </div>
                                        : ''
                                }
                                <div className="clearfix"/>
                                {/*<div >*/}
                                {/*    <Field*/}
                                {/*        name="shipping_delivery_option"*/}
                                {/*        id="shipping_delivery_option"*/}
                                {/*        component={ProductInput}*/}
                                {/*        className="form-control"*/}
                                {/*        ref="hand"*/}
                                {/*        label={locale.get('shipping_delivery_option')}*/}
                                {/*        placeholder={locale.get('shipping_delivery_option')}*/}
                                {/*        field={{data_type: "dropdown", options: this.props.sell.shipping_delivery_options_list || [] }}/>*/}

                                {/*</div>*/}
                                <div className="clearfix"/>
                                {/*{*/}
                                {/*    this.getSelectedAddress() ? <div className="alert alert-warning mb-30 text-right">{locale.get('free_shipping_notification_message')}</div> : ''*/}
                                {/*}*/}
                                {/*<div className="clearfix"/>*/}

                                {/*<div className="tooltip-field" data-tip='' data-scroll-hide={true}*/}
                                {/*     data-event="click focusin focus" data-event-off="focusout"*/}
                                {/*     data-tooltip-id='tooltip_free_shipping' data-iscapture="false" data-place="left"*/}
                                {/*     data-effect="solid" data-multiline="true">*/}

                                {/*    {*/}
                                {/*        this.canShippingToRegion('westbank') ? <Field*/}
                                {/*            type="checkbox"*/}
                                {/*            name="free_shipping"*/}
                                {/*            id="free_shipping"*/}
                                {/*            component={ProductInput}*/}
                                {/*            className="form-control"*/}
                                {/*            label={locale.get('shipping_to_westbank')}*/}
                                {/*            alt_label={locale.get('free_shipping')}*/}
                                {/*            field={{}}/>*/}
                                {/*            : ''*/}
                                {/*    }*/}
                                {/*    {*/}
                                {/*        this.canShippingToRegion('jerusalem') ? <Field*/}
                                {/*            type="checkbox"*/}
                                {/*            name="free_shipping_jerusalem"*/}
                                {/*            id="free_shipping_jerusalem"*/}
                                {/*            component={ProductInput}*/}
                                {/*            className="form-control"*/}
                                {/*            label={locale.get('shipping_to_jerusalem')}*/}
                                {/*            alt_label={locale.get('free_shipping_jerusalem')}*/}
                                {/*            field={{}}/>*/}
                                {/*            : ''*/}
                                {/*    }*/}
                                {/*    {*/}
                                {/*        this.canShippingToRegion('48_area') ? <Field*/}
                                {/*            type="checkbox"*/}
                                {/*            name="free_shipping_48"*/}
                                {/*            id="free_shipping_48"*/}
                                {/*            component={ProductInput}*/}
                                {/*            className="form-control"*/}
                                {/*            label={locale.get('shipping_to_48_area')}*/}
                                {/*            alt_label={locale.get('free_shipping_48')}*/}
                                {/*            field={{}}/>*/}
                                {/*            : ''*/}
                                {/*    }*/}
                                {/*    {*/}
                                {/*        this.canShippingToRegion('gaza') ? <Field*/}
                                {/*            type="checkbox"*/}
                                {/*            name="free_shipping_gaza"*/}
                                {/*            id="free_shipping_gaza"*/}
                                {/*            data-tooltip-id="tooltip_free_shipping"*/}
                                {/*            component={ProductInput}*/}
                                {/*            className="form-control"*/}
                                {/*            label={locale.get('shipping_to_gaza')}*/}
                                {/*            alt_label={locale.get('free_shipping_gaza')}*/}
                                {/*            field={{}}/>*/}
                                {/*            : ''*/}
                                {/*    }*/}

                                {/*    <ReactTooltip*/}
                                {/*        id='tooltip_free_shipping'>{locale.get('sell_product_tooltip_free_shipping')}</ReactTooltip>*/}
                                {/*</div>*/}

                            </div>
                        </div>
                        <div className="clearfix"></div>
                        <div className="panel-1--footer">
                            <button className="btn-1" disabled={this.props.formActions.submittingForm}><Loader
                                completed={this.props.formActions.submittingForm === false}/> {locale.get('btn_add_product_to_sell')}
                            </button>
                        </div>
                    </form>
                </div>
            </Loader>

        );
    }

}

// Maps state from store to props
const mapStateToProps = (state, ownProps) => {

    if (state.sell.seller.addresses.length === 1) {
        state.sell.pickup_from = state.sell.seller.addresses[0].id
    }

    return {
        auth: state.auth,
        sell: state.sell,
        initialValues: state.sell,
        formActions: state.formActions,
        selector: (field) => selector(state, field),
        selectorAll: () => getFormValues('sellForm')(state),
    }
};


// Maps actions to props
const mapDispatchToProps = (dispatch) => {
    return {
        changeForm: (field, value) => dispatch(changeForm('sellForm', field, value)),
        fetchProductInfo: (businessId, id) => dispatch(sellActions.fetchProduct(businessId, id)),
        toggleFormActionStatus: (status) => dispatch({
            type: 'FORM_SUBMITTING_CHANGE_STATUS',
            status: status
        }),
        redirect: (url) => dispatch(routerPush(url)),
        requiresReLogin: () => dispatch(authActions.requiresRelogin())
    }
};

Sell = reduxForm({
    form: 'sellForm',
    enableReinitialize: true,
    validate: validateSeller,
})(Sell);

export default connect(mapStateToProps, mapDispatchToProps)(Sell);

